/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/instagram'
export default icon
